import {
  AthleticsProject,
  GolfProject,
  LaunchProject,
  SimulationProject,
  AnalyticsProject,
} from "./icons";

export const projects_Obj: { [project: string]: any } = {
  "Motion2Coach Golf": GolfProject,
  // "Motion2Coach Launch": LaunchProject,
  // "Motion2Coach Athletics": AthleticsProject,
  // "Motion2Coach Simulation": SimulationProject,
  // "Motion2Coach Analytics": AnalyticsProject,
};
export const allProjects = [
  "Motion2Coach Golf",
  // "Motion2Coach Launch",
  // "Motion2Coach Athletics",
  // "Motion2Coach Simulation",
  // "Motion2Coach Analytics",
];
